export default {
  namespaced: true,
  state: {
    selectedRGStockReports: [],
  },
  mutations: {
    SELECT_RG_STOCK_REPORTS(state, ids) {
      ids.forEach(id => {
        if (!state.selectedRGStockReports.includes(id)) {
          state.selectedRGStockReports.push(id)
        }
      })
    },
    UNSELECT_RG_STOCK_REPORTS(state, ids) {
      ids.forEach(id => {
        const index = state.selectedRGStockReports.indexOf(id)
        if (index > -1) {
          state.selectedRGStockReports.splice(index, 1)
        }
      })
    },
    CLEAR_RG_STOCK_REPORT_SELECTION(state) {
      state.selectedRGStockReports = []
    },
  },
  actions: {
    selectRGStockReports(context, payload) {
      context.commit('SELECT_RG_STOCK_REPORTS', payload.ids)
    },
    unselectRGStockReports(context, payload) {
      context.commit('UNSELECT_RG_STOCK_REPORTS', payload.ids)
    },
    clearRGStockReportSelection(context) {
      context.commit('CLEAR_RG_STOCK_REPORT_SELECTION')
    },
  },
  getters: {
    selectedRGStockReports(state) {
      return state.selectedRGStockReports
    },
  },
}
